import { OPEN_DROPDOWN, CLOSE_DROPDOWN } from "./constants";

export const openDropdown = name => ({ type: OPEN_DROPDOWN, name });

export const closeDropdown = name => ({ type: CLOSE_DROPDOWN, name });
